<template>
  <div>
    <stepPan :currStep="2"></stepPan>
    <div>
      <div v-if="payType === 'weixin'">
        <weinxinCom
          :scId="scId"
          v-on:checkTradeIntervalAddressEvent="intervalAddressEventFun"
        ></weinxinCom>
      </div>
      <div v-else-if="payType === 'zhifubao'">
        <zhifubaoCom
          :scId="scId"
          v-on:checkTradeIntervalAddressEvent="intervalAddressEventFun"
        ></zhifubaoCom>
      </div>
      <div v-else-if="payType === 'yinlian'">
        <yinlianCom
          :scId="scId"
          v-on:checkTradeIntervalAddressEvent="intervalAddressEventFun"
        ></yinlianCom>
      </div>
      <div id="errorInfo" v-else>
        找不到对应的支付类型, 请尝试其他支付方式
      </div>
    </div>
    <div id="moneInfo">总金额: {{ sumMoney / 100 }}元</div>
  </div>
</template>

<script>
import weinxinCom from './payTypeRealPage/weixinPay.vue'
import zhifubaoCom from './payTypeRealPage/zhifubaoPay.vue'
import yinlianCom from './payTypeRealPage/yinlianPay.vue'
import stepPan from '../tools/setps'
export default {
  emits: ['intervalAddressEvent'],
  props: {
    scId: Number,
    sumMoney: Number,
    payType: String
  },
  data () {
    return {}
  },
  methods: {
    intervalAddressEventFun (address) {
      this.$emit('intervalAddressEvent', address)
    }
  },
  components: {
    weinxinCom,
    zhifubaoCom,
    yinlianCom,
    stepPan
  }
}
</script>

<style scoped>
#moneInfo {
  color: #fff;
  font-size: 20px;
}
#errorInfo {
  height: 100px;
  line-height: 100px;
  font-size: 20px;
}
</style>
